import React from "react";
import PATH from "constants/path";
import { getTitleDecoration, isAuthenticated } from "utils/common";
import { no_image } from "assets/img";
import { SERVICE } from "constants/global";

const CardItem = ({ item }) => {
  let display = isAuthenticated()
    ? {
        summary: item.summary_login,
        title: item.title_login,
        file: item.file_small_login,
      }
    : {
        summary: item.summary_nologin,
        title: item.title_nologin,
        file: item.file_small_nologin,
      };

  display.titleDecoration = getTitleDecoration(
    item?.title_decoration?.title_decoration_content
  );

  const path = isAuthenticated()
    ? "/promotions/" + item.id
    : `${PATH.COMMON}?service=${SERVICE}&redirect_uri=${encodeURIComponent(
        window.location.href + "promotions/" + item.id
      )}`;

  return (
    <div className="card">
      <a href={path} className="card-image">
        <img
          alt={display.title}
          src={display.file ? display.file : no_image}
        />
      </a>

      <div className="content">
        <a
          href={path}
          dangerouslySetInnerHTML={{
            __html: display.titleDecoration,
          }}
        ></a>
        <a href={path} className="d-block">
          {display?.title}
        </a>
        <p className="body"
        dangerouslySetInnerHTML={{
          __html: display?.summary,
        }}
        ></p>
      </div>
      <div className="d-flex flex-fill justify-content-end fs-11 fs-sm-10 fw-600">
        {item.effective_date && `掲載日：${item.effective_date}`}
      </div>
    </div>
  );
};

export default CardItem;
